import { render, staticRenderFns } from "./EditSalesOrderPage.vue?vue&type=template&id=74a8d272"
import script from "./EditSalesOrderPage.vue?vue&type=script&lang=js"
export * from "./EditSalesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports